import { Reducer } from 'redux';

import { IFavoriteAdd, IFavoriteRemove, ISetFavorites, ISetRemote, TFavorite, TRemote } from '../actions';
import { Favorite } from '../entities';

export interface IFavoritesState {
  [id: string]: Favorite;
}
export const defaultFavoritesState = {};

export const favoritesReducer: Reducer<IFavoritesState> = (
  state: IFavoritesState = defaultFavoritesState,
  action: ISetFavorites | IFavoriteAdd | IFavoriteRemove | ISetRemote
): IFavoritesState => {
  switch (action.type) {
    case TRemote.SET_REMOTE:
      return defaultFavoritesState;
    case TFavorite.FAVORITE_REMOVE:
      const { [action.payload]: key, ...favorites } = state;
      return { ...favorites };
    case TFavorite.SET_FAVORITES:
      return action.payload.reduce((acc, fav) => ({ ...acc, [fav.id]: fav }), {} as IFavoritesState);
  }
  return state;
};
